<template>
  <div>
    <div v-if="thread">
      <div
        v-if="thread.currenttask || preThread"
        style="margin-top:20px;border: solid 1px #cccccc;border-radius: 5px;padding: 15px;"
      >
        <div
          v-if="preThread"
          class="progress-wrapper"
          style="margin-bottom: 10px;"
        >
          <b-card-text class="mb-0">
            {{ preElapsed || elapsed(preThread) }} - <b>{{ (preThread.progress || 0) + '%' }}</b> - {{ preThread.currenttask || 'idle' }}
          </b-card-text>
          <b-progress
            v-model="preThread.progress || 0"
            :variant="preThread.status === 'idle' ? 'secondary' : (preThread.progress === 100 ? 'success' : 'primary')"
            max="100"
          />
        </div>
        <!-- BUG-650: отказ рисуется отказом. Раньше после OK в окне ошибки оставалась синяя полоса
             «96 % — Deleting temp directory...», неотличимая от идущего импорта. -->
        <div class="progress-wrapper">
          <b-card-text
            v-if="isFailed"
            class="mb-0 text-danger"
          >
            {{ elapsed(thread) }} - <b>{{ t('Thread failed') }}</b>: {{ thread.error }}
          </b-card-text>
          <b-card-text
            v-else
            class="mb-0"
          >
            {{ elapsed(thread) }} - <b>{{ (thread.progress || 0) + '%' }}</b> - {{ thread.currenttask || 'idle' }}
          </b-card-text>
          <b-progress
            v-model="thread.progress || 0"
            :variant="isFailed ? 'danger' : 'primary'"
            max="100"
          />
        </div>
        <!-- PROP-685: шаги сборки по ходу прогона — статус и число затронутых записей каждого -->
        <div
          v-if="steps.length > 0"
          style="margin-top: 10px; max-height: 320px; overflow: auto;"
        >
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th style="width: 2.5rem;">
                  #
                </th>
                <th>{{ t('Mount step') }}</th>
                <th>{{ t('Operation') }}</th>
                <th class="text-right">
                  {{ t('Records affected') }}
                </th>
                <th class="text-right">
                  {{ t('Time, s') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="s in steps"
                :key="s.n"
                :class="stepClass(s)"
              >
                <td>
                  <feather-icon
                    v-if="s.status === 'done'"
                    icon="CheckIcon"
                    class="text-success"
                  />
                  <b-spinner
                    v-else-if="s.status === 'running'"
                    small
                    variant="primary"
                  />
                  <feather-icon
                    v-else-if="s.status === 'error'"
                    icon="XIcon"
                    class="text-danger"
                  />
                  <span
                    v-else
                    class="text-muted"
                  >{{ s.n }}</span>
                </td>
                <td>
                  {{ s.name }}
                  <div
                    v-if="s.error"
                    class="text-danger small"
                  >
                    {{ s.error }}
                  </div>
                </td>
                <td class="text-muted">
                  {{ s.oper }}
                </td>
                <td class="text-right">
                  {{ s.rows === undefined ? '' : s.rows.toLocaleString('ru-RU') }}
                </td>
                <td class="text-right text-muted">
                  {{ s.sec === undefined ? '' : s.sec }}
                </td>
              </tr>
            </tbody>
            <tfoot v-if="doneCount > 0">
              <tr>
                <td />
                <td colspan="2">
                  <b>{{ t('Steps done') }}: {{ doneCount }} / {{ steps.length }}</b>
                </td>
                <td class="text-right">
                  <b>{{ totalRows.toLocaleString('ru-RU') }}</b>
                </td>
                <td />
              </tr>
            </tfoot>
          </table>
        </div>
        <b-button-toolbar
          key-nav
          aria-label="Toolbar with button groups"
          style="margin-top:15px;"
        >
          <b-button-group
            size="sm"
            class="cbs-inline-spacing"
          >
            <b-button
              :variant="activeTab === 'result' ? 'primary' : 'outline-primary'"
              @click="showTab('result')"
            >
              {{ 'Result' }}
            </b-button>
            <b-button
              :variant="activeTab === 'log' ? 'primary' : 'outline-primary'"
              @click="showTab('log')"
            >
              {{ 'Log' }}
            </b-button>
          </b-button-group>
        </b-button-toolbar>
        <div
          v-if="thread.html"
          style="margin-top: 10px;"
        >
          <p
            v-if="activeTab === 'result'"
            style="margin-top:10px;"
            v-html="thread.html"
          />
        </div>
        <div
          v-if="thread && thread.log && thread.log.length > 0"
          style="margin-top: 10px;"
        >
          <div
            v-if="activeTab === 'log'"
            style="margin-top:10px;max-height: 300px;overflow: auto; border-radius: 5px;padding:5px;margin-top:5px;"
            class="border-secondary"
          >
            <p
              v-for="(logLine, logIdx) in thread.log"
              :key="logIdx"
              style="margin-top:0px;margin-bottom:0px;"
            >
              {{ logLine }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton, BButtonGroup, BButtonToolbar, BCardText, BProgress, BSpinner,
} from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default {
  name: 'CbsThread',
  components: {
    BCardText,
    BProgress,
    BButton,
    BButtonToolbar,
    BButtonGroup,
    BSpinner,
  },
  props: {
    thread: {
      type: Object,
      default: () => ({}),
    },
    preThread: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const { t } = useI18nUtils()
    return {
      t, // i18n
    }
  },
  data() {
    return {
      showResult: false,
      showLog: false,
      activeTab: 'none',
      preElapsed: null,
    }
  },
  computed: {
    isFailed() {
      return !!this.thread && this.thread.status === 'error'
    },
    // PROP-685: живой список шагов сборки из треда; у прочих тредов его нет
    steps() {
      return (this.thread && Array.isArray(this.thread.steps)) ? this.thread.steps : []
    },
    doneCount() {
      return this.steps.filter(s => s.status === 'done').length
    },
    totalRows() {
      return this.steps.reduce((acc, s) => acc + (s.rows || 0), 0)
    },
  },
  methods: {
    stepClass(s) {
      if (s.status === 'running') return 'table-primary'
      if (s.status === 'error') return 'table-danger'
      if (s.status === 'pending') return 'text-muted'
      return ''
    },
    showTab(tab) {
      if (this.activeTab === tab) {
        this.activeTab = 'none'
      } else {
        this.activeTab = tab
      }
    },
    elapsed(thr) {
      if (!thr) return 'no_thread'
      if (!thr.start) return 'no_start'
      if (thr.start === 0) return 'null_start'
      // console.log('thr', thr)
      const finish = (thr.finish && thr.finish > 0) ? thr.finish : Date.now()
      // const currentTime = Math.floor(Date.now() / 1000) // Получаем текущее время в секундах
      const elapsedTime = Math.floor((finish - thr.start) / 1000) // Вычисляем прошедшее время в секундах
      // Вычисляем часы, минуты и секунды
      const hours = Math.floor(elapsedTime / 3600)
      const minutes = Math.floor((elapsedTime % 3600) / 60)
      const seconds = elapsedTime % 60
      // Форматируем время в формат "чч:мм:сс"
      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      if (this.preTread && this.preThread.status === 'process') {
        this.checkPreThread()
      }
      return formattedTime
    },
    delayPreThread() {
      setTimeout(() => this.timer(), 1000)
    },
    timer() {
      // console.log('checkPreThread', this.preThread)
      if (this.preThread && this.preThread.status === 'process') {
        this.preElapsed = this.elapsed(this.preThread)
        this.delayPreThread()
      }
    },
  },
}
</script>

<style scoped>

</style>
